<template>
  <section id="services" class="services mbr-box mbr-section mbr-section--relative mbr-section--fixed-size mbr-section--full-height mbr-section--bg-adapted mbr-parallax-background">
		<div class="section-overlay"></div>
		<div class="container">
			<div class="row center">
				<div class="col-md-8 col-md-offset-2 col-sm-12">
					<div class="section-title-parralax">
						<div class="process-numbers">02</div>
						<h2>services</h2>
						<p class="module-subtitle">I am passionate about what I do and I believe it reflects in the quality of my work.
						</p>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-6 right col-full right-0">
					<i class="lnr lnr-laptop-phone"></i>
					<h6>Full-Stack Development</h6>
					<p>I build end-to-end features across the stack —
						<br>from REST APIs and databases to responsive UIs.
					</p>
				</div>
				<div class="col-lg-6 left col-full left-0">
					<i class="lnr lnr-users"></i>
					<h6>User Experience</h6>
					<p>I design intuitive interfaces that let
						<br>users focus on the task, not the tool.
					</p>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-6 right col-full right-0">
					<i class="lnr lnr-database"></i>
					<h6>API &amp; Backend Systems</h6>
					<p>I design and build reliable APIs and
						<br>data models that scale with your product.
					</p>
				</div>
				<div class="col-lg-6 left col-full left-0">
					<i class="lnr lnr-chart-bars"></i>
					<h6>Testing &amp; Code Quality</h6>
					<p>I write maintainable, well-tested code
						<br>and care about long-term software health.
					</p>
				</div>
			</div>
		</div>
	</section>

</template>

<script>
export default {
  name: "Services",
  data() {
    return {
      msg: ""
    };
  }
};
</script>



<style scoped>
section#services {
  background-image: url("/static/assets/img/background.gif");
}
</style>



// WEBPACK FOOTER //
// src/components/Services.vue